import { Component } from '@angular/core';

@Component({
  selector: 'app-shop-fullwidth-grids',
  templateUrl: './shop-fullwidth-grids.component.html',
  styleUrls: ['./shop-fullwidth-grids.component.css']
})
export class ShopFullwidthGridsComponent {
// Set Topbar
  Menuoption = 'shop'
  footerVariant = 'footer-two';

/***
 * Header button list show
 */
shopPages = true;
}
